import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { BankContext } from '../context/BankContext';
import { SubContext } from '../context/SubTransactionContext';
import { AdminContext } from '../context/AdminContext';
import CountUp from 'react-countup';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import {Bar} from 'react-chartjs-2'

//register parts of chart we are using
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)
// LinearScale y-axis CategoryScale x-axis 

const AdminDashBoard = () => {
  const navigate = useNavigate();
  const {bank,getBank,isBankLoading} = useContext(BankContext);
  const { totalUsers ,getAllUser ,users} = useContext(AdminContext);
  const {allTransaction,getTransactions} = useContext(SubContext);
  const [plans, setPlans] = useState([]);
  const fetchPlans = async () => {
    try {
      const res = await fetch(SummaryApi.getAllPlans.url);
      if (!res.ok) throw new Error("Failed to fetch plans");
      const data = await res.json();
      setPlans(data.plans);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch plans");
    }
  };

  useEffect(()=>{
    const fecthDetails = async()=>{
      await getBank();
      await getAllUser();
      await getTransactions();
    }
    fecthDetails();
  },[])
  
  useEffect(()=>{
    fetchPlans();
  },[])
  console.log('here are all plans',plans);

const dashboardStats = useMemo(() =>{
    const activeUser = users.filter(user => user.status == 'Active').length;
    const recentUsers = users.slice(0,3);

    console.log(allTransaction);
    const recntTransaction = allTransaction.sort((a,b)=> new Date(b.createdAt) - new Date(a.createdAt)).slice(0,3);
    
    // 1. Define labels
    const chartLables = ['3 Weeks Ago', '2 Weeks Ago', 'Last Week', 'This Week'];
    // 2. Initialize counts
    const weeklyData = [0, 0, 0, 0];// ["3 Weeks Ago (oldest)","2 Weeks Ago",lastWeek,thisweek] they hold count of payment occurence every index have fix job what data they hold
    
    const today = new Date();
    today.setHours(23, 59, 59, 999); // End of today

    // 3. Define boundaries. CRITICAL: Create a new Date() for each.
    // This avoids mutating 'today'
    
    // Start of "This Week" (7 days ago)
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);

    // Start of "Last Week" (14 days ago)
    const twoWeeksAgo = new Date(today);
    twoWeeksAgo.setDate(today.getDate() - 14);

    // Start of "2 Weeks Ago" (21 days ago)
    const threeWeeksAgo = new Date(today);
    threeWeeksAgo.setDate(today.getDate() - 21); 

    // Start of "3 Weeks Ago" (28 days ago)
    const fourWeeksAgo = new Date(today);
    fourWeeksAgo.setDate(today.getDate() - 27); // 
    fourWeeksAgo.setHours(0, 0, 0, 0); // Start of that day


    // 4. Loop and assign transactions
    allTransaction.forEach(tx => {
      if(tx.type == 'CREDIT'){
        const txDate = new Date(tx.createdAt);

        // Check if transaction is in our 4-week window including todays transaction
        if(txDate >= fourWeeksAgo && txDate <= today){

          // FIX 3: Correct if/else logic (newest to oldest)
          if(txDate > oneWeekAgo){
            // This Week (0-7 days ago)
            weeklyData[3]++;
          }else if(txDate > twoWeeksAgo){
            // Last Week (7-14 days ago)
            weeklyData[2]++;
          }else if(txDate > threeWeeksAgo){
            // 2 Weeks Ago (14-21 days ago)
            weeklyData[1]++;
          }else{
            // 3 Weeks Ago (21-28 days ago)
            weeklyData[0]++;
          }
        }
      }
    });

    const data = weeklyData;

    const barChartData = {
      labels: chartLables,
      datasets:[
        {
          label:'Payment',
          data:data,
          backgroundColor: 'rgba(59, 130, 246, 0.5)', 
          borderColor: 'rgba(59, 130, 246, 1)',
          borderWidth: 1,
        }
      ]
    }
    return {
      activeUser,
      recentUsers,
      recntTransaction,
      barChartData
    }
  },[users,allTransaction])

  const handleLogout = async () => {
    try {
      const res = await fetch(SummaryApi.logout.url, {
        method: SummaryApi.logout.method,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (res.ok) {
        localStorage.removeItem("authToken");
        toast.success("Logout successful");
        navigate("/login");
      } else {
        toast.error("Logout failed");
      }
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <>
      <div className="bg-gray-50 min-h-screen p-8 relative">

        {/* Logout button */}
        <div className='absolute right-8 top-8'>
          <button
            onClick={handleLogout}
            className='text-white font-medium hover:bg-red-600 transition-all shadow-md bg-red-500 px-6 py-2 cursor-pointer rounded-lg'
          >
            Log out
          </button>
        </div>

        <div className="p-8 text-gray-700 font-medium text-3xl text-center">
          Welcome Admin
        </div>

        {/* Main container for all dashboard content */}
        <div className="max-w-7xl mx-auto">
          <div className="mt-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">

              {/* Bank and Transactions */}
              <div
                onClick={() => navigate('/library-admin-transaction')}
                className="bg-white shadow-xl rounded-lg p-8 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              >
                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                  🏦 Bank & Transactions
                </h2>
                <p className="text-gray-600 mb-8">
                  View your bank balance, manage your account, and see all credit/debit transactions.
                </p>
                <div>
                <h3 className="text-sm font-medium text-gray-500 uppercase">Available Balance</h3>
                {isBankLoading ?<p className='text-2xl font-medium text-center text-gray-600'>...</p> : <p className="text-3xl font-bold text-green-500">
                  {/* ₹{bank?.balance.toLocaleString('en-IN')} */}
                  {(bank?.balance != null && bank.balance != undefined) && (<CountUp 
                    start={0}
                    end={bank?.balance}
                    prefix='₹'
                    separator=','
                    duration={0.50}
                  />)}
                </p>}
              </div>
              </div>

              {/* User and Subscriptions */}
              <div
                onClick={() => navigate('/library-admin-userManagement')}
                className="bg-white shadow-xl rounded-lg p-8 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              >
                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                  👥 User & Subscriptions
                </h2>
                <p className="text-gray-600 mb-8">
                  View, edit, and manage all registered users and their subscriptions.
                </p>
                {/* add new details  */}
                <div className='grid grid-col-1 md:grid-cols-2 gap-8'>
                   <div className='text-center'>
                    <h3 className="text-sm font-medium text-gray-500 uppercase">Total Customers</h3>
                    {isBankLoading ?<p className='text-2xl font-medium text-center text-gray-600'>...</p> : <p className="text-3xl font-bold text-gray-900">
                        {(totalUsers !== null && totalUsers !== undefined) && (
                          <CountUp 
                            start={0}
                            end={totalUsers}
                            duration={0.50}
                          />
                        )}
                    </p>
                    }
                  </div>
                  <div className='text-center'>
                    <h3 className="text-sm font-medium text-gray-500 uppercase">Active Customers</h3>
                    {isBankLoading ?<p className='text-2xl font-medium text-center text-gray-600'>...</p> : <p className="text-3xl font-bold text-green-500">
      
                      {(dashboardStats?.activeUser !== null && dashboardStats?.activeUser !== undefined) && (
                        <CountUp 
                          start={0}
                          end={dashboardStats.activeUser}
                          duration={0.50}
                        />
                      )}
                    </p>}
                </div>
                </div>
              </div>

              {/* 📘 Plans Management */}
              <div
                onClick={() => navigate('/library-admin-plans')}
                className="bg-white shadow-xl rounded-lg p-8 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              >
                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                  📘 Plans Management
                </h2>
                <p className="text-gray-600 mb-[52px]">
                  Create and manage library membership plans.
                </p>
                <div className='text-center'>
                    <h3 className="text-sm font-medium text-gray-500 uppercase">Total Plans</h3>
                    {isBankLoading ?<p className='text-2xl font-medium text-center text-gray-600'>...</p> : <p className="text-3xl font-bold text-gray-900">
                      <CountUp 
                        start={0}
                        end={plans.length}
                        duration={0.50}
                      />
                    </p>}
                </div>
                </div>
            </div>
          </div>

          {/* ================================== */}
          {/* == NEW: Row 2: Charts           == */}
          {/* ================================== */}
          <div className="mb-8">
            
            {/* Chart 1: Subscriptions Bar Chart */}
            <div className="lg:col-span-3 bg-white shadow-lg rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Subscription Payments (Last 30 Days)</h3>
                <div className='h-80'>
                    <Bar 
                      data={dashboardStats.barChartData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins:{
                          legend:{
                             position:'top'
                            },
                        },
                        scales:{
                          y:{
                            beginAtZero:true,
                            ticks:{
                              // Ensure only whole numbers are used on the Y-axis
                              stepSize:1  
                            }
                          }
                        }
                      }}
                    />
                </div>
            </div>
          </div>

          {/* ================================== */}
          {/* == NEW: Row 3: Activity Lists   == */}
          {/* ================================== */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
            
            {/* List 1: Recent Transactions */}
            <div className="bg-white shadow-lg rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Recent Transactions</h3>
              <ul className="divide-y divide-gray-200">
                {dashboardStats.recntTransaction.map((tx)=> (
                  <li key={tx._id} className="flex justify-between items-center py-3">
                  <div>
                    <p className="font-medium text-gray-800">{tx?.userId?.name}</p>
                    <p className="text-sm text-gray-500">{tx.description}</p>
                  </div>
                  <span className="font-medium text-green-600">₹{tx.amount}</span>
                </li>
                ))
                }   
              </ul>
            </div>

            {/* List 2: Recent New Customers */}
            <div className="bg-white shadow-lg rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Recent New Customers</h3>
              <ul className="divide-y divide-gray-200">
                {dashboardStats.recentUsers.map((user)=> (
                 <li key={user._id} className="py-3">
                  <p className="font-medium text-gray-800">{user.name}</p>
                  <p className="text-sm text-gray-500">{user.email}</p>
                </li>
                ))
                }
              </ul>
            </div>
          </div>



        </div> {/* End of max-w-7xl container */}
      </div>
    </>
  );
};

export default AdminDashBoard;